import Icon from '@/components/ui/AppIcon';

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-primary via-secondary to-primary">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <h2 className="text-3xl lg:text-5xl font-display font-bold text-white">
            Ready to Experience Proximus?
          </h2>
          <p className="text-lg lg:text-xl text-white/90 max-w-2xl mx-auto">
            Join hundreds of satisfied business travelers and extended-stay guests who have made Proximus their Bangalore home base
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <a
              href="https://bookingengine.stayflexi.com/?hotel_id=33526"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-accent hover:bg-accent/90 text-white font-semibold rounded-lg shadow-elevated transition-all duration-300 hover:scale-105 flex items-center justify-center space-x-2">

              <span>Book Your Stay</span>
              <Icon name="CalendarIcon" size={20} className="text-white" />
            </a>
            <a
              href="/apartment-categories"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white font-semibold rounded-lg border-2 border-white/30 transition-all duration-300 flex items-center justify-center space-x-2">

              <span>View Apartments</span>
              <Icon name="HomeIcon" size={20} className="text-white" />
            </a>
          </div>

          <div className="grid md:grid-cols-3 gap-6 pt-12">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 space-y-3">
              <Icon name="PhoneIcon" size={32} className="text-accent mx-auto" />
              <h4 className="font-semibold text-white">Call Us</h4>
              <p className="text-white/80 text-sm">+91 72593 12233</p>
              <p className="text-white/60 text-xs">Available 24/7</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 space-y-3">
              <Icon name="EnvelopeIcon" size={32} className="text-accent mx-auto" />
              <h4 className="font-semibold text-white">Email Us</h4>
              <p className="text-white/80 text-sm">enquiry@proximusindia.com</p>
              <p className="text-white/60 text-xs">Response within 2 hours</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 space-y-3">
              <Icon name="MapPinIcon" size={32} className="text-accent mx-auto" />
              <h4 className="font-semibold text-white">Visit Us</h4>
              <p className="text-white/80 text-sm">Bilekahalli</p>
              <p className="text-white/60 text-xs">Bangalore, Karnataka</p>
            </div>
          </div>
        </div>
      </div>
    </section>);

}